import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class GameoverScreen extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let keyboardInput = new Website.game.screens.KeyboardInput();
        keyboardInput.item.screen = this.item;
        this.item.requireProperty("keyboardInput", keyboardInput.item);

        
        this.item.requireProperty("game", null);
        this.item.requireProperty("logoEnvelope", 0);
        this.item.requireProperty("buttonEnvelope", 0);
        this.item.requireProperty("animationState", "none").addUpdate(this._getScopedCallFunctionCommand(this._animationStateChanged));
        this.item.requireProperty("papers", []);
        this.item.requireProperty("interactionMode", "none");

        let layer = new PIXI.Container()
        this.item.requireProperty("pixiLayer", layer);

        this.item.requireProperty("physicsEngine", 0);
        this.item.physicsEngine = Matter.Engine.create();
        this.item.physicsEngine.gravity.y = 1.4;

        let floorBody = Matter.Bodies.rectangle(0, 20, 2*Website.game.Sizes.WIDTH, 40, {
            isStatic: true,
            label: "ground",
            restitution: 0,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.GROUND, Website.game.PhysicsGroups.GROUND_INTERACTIONS)
        });
        
        Matter.World.add(this.item.physicsEngine.world, floorBody);

        let leftWall = Matter.Bodies.rectangle(-80, -0.5*Website.game.Sizes.HEIGHT, 20, Website.game.Sizes.HEIGHT, {
            isStatic: true,
            label: "ground",
            restitution: 0,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.GROUND, Website.game.PhysicsGroups.GROUND_INTERACTIONS)
        });

        Matter.World.add(this.item.physicsEngine.world, leftWall);

        let rightWall = Matter.Bodies.rectangle(300, -0.5*Website.game.Sizes.HEIGHT, 20, Website.game.Sizes.HEIGHT, {
            isStatic: true,
            label: "ground",
            restitution: 0,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.GROUND, Website.game.PhysicsGroups.GROUND_INTERACTIONS)
        });

        Matter.World.add(this.item.physicsEngine.world, rightWall);
        
        let table = new Website.game.screens.gameover.Table();
        this.item.setValue("table", table.item);

        Matter.Body.setPosition(table.item.physicsBody, {
            x: Website.game.Sizes.CENTER_X-10,
            y: -19
        });
        
        Matter.World.add(this.item.physicsEngine.world, table.item.physicsBody);

        Matter.Events.on(this.item.physicsEngine, "collisionStart", this._callback_collisionStart.bind(this));


    }

    _callback_collisionStart(aEvent) {
        for (const pair of aEvent.pairs) {
            //console.log(pair.bodyA.label, pair.bodyB.label);
            
            /*
            if (pair.bodyA.label === "paper") {
                Matter.Body.setVelocity(pair.bodyA, {
                    x: pair.bodyA.velocity.x * 0.9,
                    y: pair.bodyA.velocity.y * 0.9
                });
            }

            if (pair.bodyB.label === "paper") {
                Matter.Body.setVelocity(pair.bodyB, {
                    x: pair.bodyB.velocity.x * 0.9,
                    y: pair.bodyB.velocity.y * 0.9
                });
            }
            */
        }
    }

    _callback_startClicked(aEvent) {
        this.item.game.level = 1;
        this.item.game.score = 0;
        this.item.game.gamePlay.controller.reset();
        this.item.game.gamePlay.controller.setupLevel();
        this.item.game.controller.startRun();

        this.item.game.controller.changeScreen("loadingLevel");

        let sound = Website.game.getTextures("sounds/interface", "click-beep")[0];
        sound.play({loop: false, volume: 0.5});
    }

    _callback_backClicked() {
        this.item.game.level = 1;
        this.item.game.score = 0;
        this.item.game.gamePlay.controller.reset();
        this.item.game.controller.changeScreen("selectCharacter");

        let sound = Website.game.getTextures("sounds/interface", "click-beep")[0];
        sound.play({loop: false, volume: 0.5});
    }

    prepare() {
        //console.log("prepare");

        let layer = this.item.pixiLayer;

        let logo = new PIXI.Container();
        layer.addChild(logo);
        this.item.setValue("logo", logo);

        

        let texture = Website.game.getTextures("screens/gameover", "background")[0];

        let sprite = new PIXI.Sprite(texture);
        this.item.logo.addChild(sprite);

        let posterTexture = Website.game.getTextures("screens/gameover/poster", "red-tape")[0];

        let poster = new PIXI.Sprite(posterTexture);
        this.item.logo.addChild(poster);
        poster.position.set(191, 43);
        this.item.setValue("poster", poster);

        let gameOverText = Dbm.getRepositoryItem("game").controller.getText("GAME OVER", 16, 0xFFFFFF);
        gameOverText.position.set(10, 10);
        this.item.pixiLayer.addChild(gameOverText);

        let player = new Website.game.gameplay.player.Player();
        this.item.setValue("player", player.item);
        this.item.pixiLayer.addChild(this.item.player.pixiLayer);

        this.item.player.pixiLayer.x = -0.5*Website.game.Sizes.CHARACTER_WIDTH;
        this.item.player.pixiLayer.y = Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION;

        let playerAnimation = Dbm.flow.externalObject(this.item.player.pixiLayer);
        playerAnimation.addProperty("x", -0.5*Website.game.Sizes.CHARACTER_WIDTH);
        this.item.setValue("playerAnimation", playerAnimation.item);

        let boss = Dbm.flow.externalObject(new PIXI.Container());
        this.item.setValue("boss", boss.item);
        boss.object.position.set(Website.game.Sizes.CENTER_X-10, Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION+5);
        boss.addProperty("x", Website.game.Sizes.CENTER_X-10, "position.x");
        boss.addProperty("y", Website.game.Sizes.CENTER_X-10, "position.y");
        this.item.pixiLayer.addChild(boss.object);

        let bossGraphics = new Website.game.gameplay.player.SwitchableGraphics();
        this.item.setValue("bossGraphics", bossGraphics.item);
        boss.object.addChild(bossGraphics.item.pixiLayer);

        bossGraphics.addGraphics("idle", Website.game.getSprite("enemies/boss", "full"));
        bossGraphics.addGraphics("prepareHit", Website.game.getSprite("enemies/boss", "layer-01-stamp"));
        bossGraphics.addGraphics("hit", Website.game.getSprite("enemies/boss", "layer-01-stamp-down"));

        let table = Website.game.getSprite("screens/gameover", "table");
        table.anchor.set(0.5, 0.5);

        let tableStamped = Website.game.getSprite("screens/gameover", "table", 1);
        tableStamped.anchor.set(0.5, 0.5);

        let tableGraphics = new Website.game.gameplay.player.SwitchableGraphics();
        this.item.setValue("tableGraphics", tableGraphics.item);
        boss.object.addChild(bossGraphics.item.pixiLayer);

        tableGraphics.addGraphics("normal", table);
        tableGraphics.addGraphics("stamped", tableStamped);
        
        this.item.table.pixiLayer.addChild(tableGraphics.item.pixiLayer);
        this.item.pixiLayer.addChild(this.item.table.pixiLayer);

        let bossOverlayGraphics = new Website.game.gameplay.player.SwitchableGraphics();
        this.item.setValue("bossOverlayGraphics", bossOverlayGraphics.item);
        this.item.pixiLayer.addChild(bossOverlayGraphics.item.pixiLayer);
        bossOverlayGraphics.item.pixiLayer.position.set(Website.game.Sizes.CENTER_X-10, Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION+5);

        bossOverlayGraphics.addGraphics("idle", new PIXI.Container());
        bossOverlayGraphics.addGraphics("prepareHit", new PIXI.Container());
        bossOverlayGraphics.addGraphics("hit", Website.game.getSprite("enemies/boss", "overlay-stamp-down"));

        

        let physicsLayer = new PIXI.Container();
        this.item.pixiLayer.addChild(physicsLayer);
        this.item.setValue("physicsLayer", physicsLayer);

        let speechBubble = new Website.game.gameplay.player.SpeechBubble();
        this.item.setValue("speechBubble", speechBubble.item);
        speechBubble.setup(90, false);
        speechBubble.setText("Färre idéer. Fler blanketter!");
        speechBubble.item.pixiLayer.position.set(140, 90);
        this.item.pixiLayer.addChild(speechBubble.item.pixiLayer);

        /*
        {
            let sign = new PIXI.Container();
            
            this.item.pixiLayer.addChild(sign);

            const box = Website.game.getButton("screens/frame", "main", 0, 7);
            sign.addChild(box);

            let text = Dbm.getRepositoryItem("game").controller.getText("Byråkratimyndighetsverket", 16, 0x00000);
            this.item.textSprite = text;
        
            let margin = 7;
            text.position.x = margin;
            text.position.y = margin;

            box.width = text.width+2*margin;
            box.height = text.height+2*margin;

            sign.position.set(Math.round(0.5*(Website.game.Sizes.WIDTH-(text.width+2*margin)))-10, 30);
            sign.addChild(text);
        }
        */

        let overlayLayer = Dbm.flow.externalObject(new PIXI.Container());
        overlayLayer.addProperty("y", Website.game.Sizes.HEIGHT, "position.y");
        overlayLayer.object.y = Website.game.Sizes.HEIGHT;
        this.item.pixiLayer.addChild(overlayLayer.object);
        this.item.setValue("overlayLayer", overlayLayer.item);

        let textBoxWidth = 300;
        
        let textBox = Dbm.flow.externalObject(new PIXI.Container());
        overlayLayer.object.addChild(textBox.object);
        this.item.setValue("textBox", textBox.item);

        textBox.object.position.x = 0.5*(Website.game.Sizes.WIDTH-textBoxWidth);
        textBox.object.position.y = 10+16;

        const textBoxBackground = Website.game.getButton("screens/frame", "main", 0, 7);
        textBoxBackground.width = textBoxWidth;
        this.item.setValue("textBoxBackground", textBoxBackground);

        textBox.object.addChild(textBoxBackground);
        
        {
            let text = Dbm.getRepositoryItem("game").controller.getText("Du tog dig långt och plockade ______ Tillväxtpoäng på vägen - snyggt jobbat.\nIbland vinner man, ibland lär man sig. Tryck på spela igen och omsätt din läropeng i fler poäng.\nNär företag växer skapas fler jobb, bättre produkter och tjänster och i slutändan mer resurser till välfärden.\nSmå steg -> stort resultat.", 10, 0x000000, {wordWrap: true, wordWrapWidth: textBoxWidth-2*10, lineHeight: 18});
            text.position.set(10, 10);
            textBox.object.addChild(text);
            this.item.setValue("text", text);
            this.item.textBoxBackground.height = this.item.text.height+2*10;
        }

        let buttonHeight = 20;
        let buttonWidth = 120;

        let backButton = new PIXI.Container();
        backButton.eventMode = "static";
        backButton.on("pointerdown", this._callback_backClicked.bind(this));
        overlayLayer.object.addChild(backButton);
        this.item.setValue("backButton", backButton);
        
        {
            const box = Website.game.getButton("screens/button-orange");
            box.width = buttonWidth;
            box.height = buttonHeight;
            backButton.addChild(box);

            backButton.x = 10;
            backButton.y = Website.game.Sizes.HEIGHT-buttonHeight-10;

            let text = Dbm.getRepositoryItem("game").controller.getText("VÄLJ HJÄLTE");
        
            text.position.x = 0.5*(buttonWidth-text.width);
            text.position.y = 0.5*(buttonHeight-text.height);

            backButton.addChild(text);
        }

        let startButton = new PIXI.Container();
        startButton.eventMode = "static";
        startButton.on("pointerdown", this._callback_startClicked.bind(this));
        overlayLayer.object.addChild(startButton);
        this.item.setValue("startButton", startButton);

        const box = Website.game.getButton();
        box.width = buttonWidth;
        box.height = buttonHeight;
        this.item.startButton.addChild(box);

        this.item.startButton.x = Website.game.Sizes.WIDTH-buttonWidth-10;
        this.item.startButton.y = Website.game.Sizes.HEIGHT-buttonHeight-10;
        
        let text = Dbm.getRepositoryItem("game").controller.getText("SPELA IGEN");
        
        text.position.x = 0.5*(buttonWidth-text.width);
        text.position.y = 0.5*(buttonHeight-text.height);

        this.item.startButton.addChild(text);

        let scoreDisplay = new Website.game.gameplay.graphics.ScoreDisplay();
        this.item.pixiLayer.addChild(scoreDisplay.item.pixiLayer);
        this.item.setValue("scoreDisplay", scoreDisplay.item);

        let playerId = this.item.game.playerId;
        this.item.player.controller.setupGraphics(playerId);



        this._setupHighscoreBox();
        this._setupHighscoreFormBox();
        
        /*
        const render = Matter.Render.create({
          element: document.body,
          engine: this.item.physicsEngine,
          options: {
            width: Website.game.Sizes.WIDTH*3,
            height: Website.game.Sizes.HEIGHT*3,
            wireframes: false,
            background: "transparent",
            showVelocity: true,
            showAngleIndicator: true,
            showCollisions: true,
            showAxes: true
          }
        });
        
        Matter.Render.lookAt(render, {
          min: { x: 0, y: -1*Website.game.Sizes.GROUND_POSITION },
          max: { x: Website.game.Sizes.WIDTH, y: Website.game.Sizes.HEIGHT-Website.game.Sizes.GROUND_POSITION }
        });
        
        Matter.Render.run(render);
        */
    }

    _setupHighscoreBox() {
        let textBoxWidth = 160;
        let buttonHeight = 20;
        let buttonWidth = 36;
        
        let textBox = Dbm.flow.externalObject(new PIXI.Container());
        this.item.pixiLayer.addChild(textBox.object);
        textBox.addProperty("alpha", 0);
        textBox.addProperty("scale", 0);
        this.item.setValue("highscorePrompt", textBox.item)

        let holder = new PIXI.Container();
        textBox.object.addChild(holder);

        textBox.object.position.x = Math.round(0.5*(Website.game.Sizes.WIDTH));
        textBox.object.position.y = Math.round(0.5*(Website.game.Sizes.HEIGHT));

        holder.position.x = -1*Math.round(0.5*textBoxWidth);

        const textBoxBackground = Website.game.get9Sliced("screens/computer-window", "main", 0, 2, 8, 14, 2);
        textBoxBackground.width = textBoxWidth;

        holder.addChild(textBoxBackground);

        let topPosition = 6;
        let margin = 5;
        
        let textHeight = 0;
        {
            let text = Dbm.getRepositoryItem("game").controller.getText("NYTT HIGHSCORE! Vill du skicka till topplistan?", 10, 0x000000, {wordWrap: true, wordWrapWidth: textBoxWidth-2*10, lineHeight: 18});
            text.position.set(margin, topPosition+margin);
            holder.addChild(text);
            textHeight = text.height;
            
        }

        let fullHeight = textHeight+topPosition+2*margin+buttonHeight+margin;
        textBoxBackground.height = fullHeight;
        
        holder.position.y = -1*Math.round(0.5*fullHeight);

        let backButton = new PIXI.Container();
        backButton.eventMode = "static";
        backButton.on("pointerdown", this._highscoreOver.bind(this));
        holder.addChild(backButton);
        
        {
            const box = Website.game.getButton("screens/button-orange");
            box.width = buttonWidth;
            box.height = buttonHeight;
            backButton.addChild(box);

            backButton.x = margin;
            backButton.y = textHeight+topPosition+2*margin;

            let text = Dbm.getRepositoryItem("game").controller.getText("NEJ");
        
            text.position.x = 0.5*(buttonWidth-text.width);
            text.position.y = 0.5*(buttonHeight-text.height);

            backButton.addChild(text);
        }

        let startButton = new PIXI.Container();
        startButton.eventMode = "static";
        startButton.on("pointerdown", this._showHighscoreForm.bind(this));
        holder.addChild(startButton);

        const box = Website.game.getButton();
        box.width = buttonWidth;
        box.height = buttonHeight;
        startButton.addChild(box);

        startButton.x = textBoxWidth-buttonWidth-margin;
        startButton.y = textHeight+topPosition+2*margin;
        
        let text = Dbm.getRepositoryItem("game").controller.getText("JA");
        
        text.position.x = 0.5*(buttonWidth-text.width);
        text.position.y = 0.5*(buttonHeight-text.height);

        startButton.addChild(text);
    }

    _setupHighscoreFormBox() {
        let textBoxWidth = 240;
        let buttonHeight = 20;
        let buttonWidth = 64;
        
        let textBox = Dbm.flow.externalObject(new PIXI.Container());
        this.item.pixiLayer.addChild(textBox.object);
        textBox.addProperty("alpha", 0);
        textBox.addProperty("scale", 0);
        this.item.setValue("highscoreForm", textBox.item)

        let holder = new PIXI.Container();
        textBox.object.addChild(holder);

        textBox.object.position.x = Math.round(0.5*(Website.game.Sizes.WIDTH));
        textBox.object.position.y = Math.round(0.5*(Website.game.Sizes.HEIGHT));

        holder.position.x = -1*Math.round(0.5*textBoxWidth);

        const textBoxBackground = Website.game.get9Sliced("screens/computer-window", "main", 0, 2, 8, 14, 2);
        textBoxBackground.width = textBoxWidth;

        holder.addChild(textBoxBackground);

        let topPosition = 6;
        let margin = 5;
        
        let textHeight = 60;

        let fullHeight = textHeight+topPosition+2*margin+buttonHeight+margin;
        textBoxBackground.height = fullHeight;
        
        holder.position.y = -1*Math.round(0.5*fullHeight);

        

        if(Dbm.repository.getItem("site").gameMode === "arcade") {
            let form = new Website.game.screens.ArcadeHighscoreForm();
            form.item.scene = this.item;
            form.setup();
            this.item.setValue("arcadeHighscoreForm", form.item);
            holder.addChild(form.item.pixiLayer);
        }
        else {
            let backButton = new PIXI.Container();
            backButton.eventMode = "static";
            backButton.on("pointerdown", this._highscoreOver.bind(this));
            holder.addChild(backButton);
            
            {
                const box = Website.game.getButton("screens/button-orange");
                box.width = buttonWidth;
                box.height = buttonHeight;
                backButton.addChild(box);

                backButton.x = margin;
                backButton.y = textHeight+topPosition+2*margin;

                let text = Dbm.getRepositoryItem("game").controller.getText("AVBRYT");
            
                text.position.x = 0.5*(buttonWidth-text.width);
                text.position.y = 0.5*(buttonHeight-text.height);

                backButton.addChild(text);
            }

            let startButton = new PIXI.Container();
            startButton.eventMode = "static";
            startButton.on("pointerdown", this._submitHighscoreForm.bind(this));
            holder.addChild(startButton);

            const box = Website.game.getButton();
            box.width = buttonWidth;
            box.height = buttonHeight;
            startButton.addChild(box);

            startButton.x = textBoxWidth-buttonWidth-margin;
            startButton.y = textHeight+topPosition+2*margin;
            
            let text = Dbm.getRepositoryItem("game").controller.getText("SKICKA");
            
            text.position.x = 0.5*(buttonWidth-text.width);
            text.position.y = 0.5*(buttonHeight-text.height);

            startButton.addChild(text);
        }
    }

    _showHighscoreForm() {
        //console.log("_showHighscoreForm");

        this.item.interactionMode = "highscore";

        if(Dbm.repository.getItem("site").gameMode !== "arcade") {
            this.item.game.properties.showHighscoreForm.delayValue(true, 0.4);
        }

        this.item.highscoreForm.properties.alpha.animateValue(1, 0.3, 0);
        this.item.highscoreForm.properties.scale.animateValue(1.2, 0.3, 0);
        this.item.highscoreForm.properties.scale.addAdditionalAnimation(1.2, 1, 0.1, 0.3, Dbm.getRepositoryItem("easingFunctions").easeIn);

        let sound = Website.game.getTextures("sounds/interface", "computer-beep")[0];
        sound.play({loop: false, volume: 0.5});
    }

    _submitHighscoreForm() {
        if(this.item.game.termsChecked) {
            this.item.game.controller.submitHighscore();
            this._highscoreOver();
        }
    }

    _startPhysics() {
        Matter.Body.setPosition(this.item.table.physicsBody, {
            x: Website.game.Sizes.CENTER_X-10,
            y: -19
        });
        Matter.Body.setInertia(this.item.table.physicsBody, Infinity);

        for(let i = 0; i < 3; i++) {

            let paper = new Website.game.screens.gameover.Paper();
            paper.setup(false);
            paper.createStack();
            paper.item.groundOffset = 7;

            let randomOffset = 1*((Math.random()*2-1));

            this.item.physicsLayer.addChild(paper.item.pixiLayer);

            let stackHeight = 8;

            Matter.Body.setPosition(paper.item.physicsBody, {
                x: Website.game.Sizes.CENTER_X-10+30+randomOffset,
                y: -38-(0.5*stackHeight)-i*stackHeight
            });
    
            Matter.World.add(this.item.physicsEngine.world, paper.item.physicsBody);
            this.item.addToArray("papers", paper.item);
        }

        {
            let paper = new Website.game.screens.gameover.Airplane();
            paper.setup(false);
            paper.createGraphics();
            paper.item.groundOffset = 5;

            this.item.physicsLayer.addChild(paper.item.pixiLayer);

            let stackHeight = 8;

            Matter.Body.setPosition(paper.item.physicsBody, {
                x: Website.game.Sizes.CENTER_X+10,
                y: -70
            });

            Matter.Body.setVelocity(paper.item.physicsBody, {
                x: -6.5,
                y: -6
            });
    
            Matter.World.add(this.item.physicsEngine.world, paper.item.physicsBody);
            this.item.addToArray("papers", paper.item);
        }

        for(let i = 0; i < 5; i++) {

            let paper = new Website.game.screens.gameover.Paper();
            paper.setup();
            paper.createStack();
            paper.item.groundOffset = 5;

            let randomOffset = 1*((Math.random()*2-1));

            this.item.physicsLayer.addChild(paper.item.pixiLayer);

            let stackHeight = 8;

            Matter.Body.setPosition(paper.item.physicsBody, {
                x: Website.game.Sizes.CENTER_X-10-45+randomOffset,
                y: -38-(0.5*stackHeight)-i*stackHeight
            });
    
            Matter.World.add(this.item.physicsEngine.world, paper.item.physicsBody);
            this.item.addToArray("papers", paper.item);
        }

        {
            let paper = new Website.game.screens.gameover.Airplane();
            paper.setup();
            paper.createGraphics();
            paper.item.groundOffset = 5;

            this.item.physicsLayer.addChild(paper.item.pixiLayer);

            let stackHeight = 8;

            Matter.Body.setPosition(paper.item.physicsBody, {
                x: Website.game.Sizes.CENTER_X-10-45,
                y: -38-(0.5*stackHeight)-5*stackHeight
            });
    
            Matter.World.add(this.item.physicsEngine.world, paper.item.physicsBody);
            this.item.addToArray("papers", paper.item);
        }

        

        for(let i = 0; i < 7; i++) {

            let paper = new Website.game.screens.gameover.Paper();
            paper.setup();
            paper.createStack();

            let randomOffset = 1*((Math.random()*2-1));

            this.item.physicsLayer.addChild(paper.item.pixiLayer);

            let stackHeight = 8;

            Matter.Body.setPosition(paper.item.physicsBody, {
                x: Website.game.Sizes.CENTER_X-10+40+randomOffset,
                y: -38-(0.5*stackHeight)-i*stackHeight
            });
    
            Matter.World.add(this.item.physicsEngine.world, paper.item.physicsBody);
            this.item.addToArray("papers", paper.item);
        }
    }

    start() {
        this.item.keyboardInput.active = true;

        this._startPhysics();
        this.item.animationState = "none";
        this.item.properties.animationState.addDelayValue("stopWalk", 1);
        this.item.properties.animationState.addDelayValue("prepareHit", 1.5);
        this.item.properties.animationState.addDelayValue("hit", 2);
        this.item.properties.animationState.addDelayValue("hitDone", 2.2);
        this.item.properties.animationState.addDelayValue("endTalk", 4.5);

        let playerId = this.item.game.playerId;
        this.item.player.controller.setupGraphics(playerId);

        if(playerId === "saga") {
            let posterTexture = Website.game.getTextures("screens/gameover/poster", "red-tape")[0];
            this.item.poster.texture = posterTexture;
        }
        else if(playerId === "theo") {
            let posterTexture = Website.game.getTextures("screens/gameover/poster", "computer")[0];
            this.item.poster.texture = posterTexture;
        }
        if(playerId === "affe") {
            let posterTexture = Website.game.getTextures("screens/gameover/poster", "stone")[0];
            this.item.poster.texture = posterTexture;
        }
        if(playerId === "ninni") {
            let posterTexture = Website.game.getTextures("screens/gameover/poster", "milk")[0];
            this.item.poster.texture = posterTexture;
        }
        if(playerId === "svenne") {
            let posterTexture = Website.game.getTextures("screens/gameover/poster", "log")[0];
            this.item.poster.texture = posterTexture;
        }
        

        this.item.player.controller.startWalk();

        let bossX = Website.game.Sizes.CENTER_X-10;
        let bossY = Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION+5;

        this.item.boss.object.position.set(bossX+20, bossY);
        this.item.boss.x = bossX+20;
        this.item.boss.y = bossY-10;

        this.item.boss.properties.x.animateValue(bossX, 0.4, 0, (value) => value);
        this.item.boss.properties.y.animateValue(bossY, 0.4);

        this.item.tableGraphics.controller.showGraphics("normal");

        this.item.buttonEnvelope = 0;
        this.item.properties.buttonEnvelope.animateValue(1, 0.8, 5.2);

        this.item.playerAnimation.x = -0.5*Website.game.Sizes.CHARACTER_WIDTH;
        this.item.playerAnimation.properties.x.animateValue(65-0.5*Website.game.Sizes.CHARACTER_WIDTH, 1, 0, (value) => value);

        this.item.overlayLayer.y = Website.game.Sizes.HEIGHT;
        
        
        
        this.item.scoreDisplay.score = this.item.game.score;

        this.item.text.text = "Du tog dig långt och plockade " + this.item.game.score + " Tillväxtpoäng på vägen - snyggt jobbat.\n\nIbland vinner man, ibland lär man sig. Tryck på spela igen och omsätt din läropeng i fler poäng.\n\nNär företag växer skapas fler jobb, bättre produkter och tjänster och i slutändan mer resurser till välfärden.\n\nSmå steg -> stort resultat.";
        this.item.textBoxBackground.height = this.item.text.height+2*10;

        if(this.item.game.score === this.item.game.highScore) {
            setTimeout(() => {
                this.item.scoreDisplay.controller.showHighscore();
            }, 0.5*1000);

            this.item.highscorePrompt.properties.alpha.animateValue(1, 0.3, 4.5);
            this.item.highscorePrompt.properties.scale.animateValue(1.2, 0.3, 4.5);
            this.item.highscorePrompt.properties.scale.addAdditionalAnimation(1.2, 1, 0.1, 4.8, Dbm.getRepositoryItem("easingFunctions").easeIn);

            //this.item.overlayLayer.properties.y.animateValue(0, 0.7, 4.5);
        }
        else {
            this.item.overlayLayer.properties.y.animateValue(0, 0.7, 4.5);
        }
    }

    _highscoreOver() {

        this.item.game.showHighscoreForm = false;

        this.item.highscorePrompt.properties.alpha.animateValue(0, 0.3, 0);
        this.item.highscorePrompt.properties.scale.animateValue(0, 0.3, 0);

        this.item.highscoreForm.properties.alpha.animateValue(0, 0.3, 0);
        this.item.highscoreForm.properties.scale.animateValue(0, 0.3, 0);

        this.item.overlayLayer.properties.y.animateValue(0, 0.7, 0);

        let sound = Website.game.getTextures("sounds/interface", "click-beep")[0];
        sound.play({loop: false, volume: 0.5});

        this.item.interactionMode = "ended";

        if(Dbm.repository.getItem("site").gameMode === "arcade") {
            this.item.game.highScore = 0;
        }
    }

    _animationStateChanged() {
        let currentState = this.item.animationState;
        //console.log(currentState);

        if(currentState === "stopWalk") {
            this.item.player.controller.stand();
        }
        if(currentState === "prepareHit") {
            this.item.bossGraphics.controller.showGraphics("prepareHit");
            this.item.bossOverlayGraphics.controller.showGraphics("prepareHit");
        }
        if(currentState === "hit") {
            this.item.bossGraphics.controller.showGraphics("hit");
            this.item.bossOverlayGraphics.controller.showGraphics("hit");
            //this.item.tableGraphics.controller.showGraphics("stamped");

            Matter.Body.setInertia(this.item.table.physicsBody, this.item.table.originalInertia);
            let currentArray = this.item.papers;
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentPaper = currentArray[i];
                Matter.Body.setInertia(currentPaper.physicsBody, currentPaper.originalInertia);
            }

            let impactFrom = {x: this.item.table.physicsBody.position.x, y: this.item.table.physicsBody.position.y};

            impactFrom.x += 50*(Math.random()*2-1);
            impactFrom.y += 20*(Math.random()*2-1);

            let xForce = 0.02*(Math.random()*2-1);
            let yForce = 0.15+0.1*Math.random();

            Matter.Body.applyForce(this.item.table.physicsBody, impactFrom, {x: xForce, y: -1*yForce});

            let sound = Website.game.getTextures("sounds/interface", "hit-table")[0];
            sound.play({loop: false, volume: 0.5});
        }
        if(currentState === "hitDone") {
            this.item.bossGraphics.controller.showGraphics("idle");
            this.item.bossOverlayGraphics.controller.showGraphics("idle");

            this.item.speechBubble.controller.show();
        }
        if(currentState === "endTalk") {
            this.item.speechBubble.controller.hide();

            if(this.item.game.score === this.item.game.highScore) {
                let sound = Website.game.getTextures("sounds/interface", "computer-beep")[0];
                sound.play({loop: false, volume: 0.5});
                this.item.interactionMode = "highscorePrompt";
            }
            else {
                this.item.interactionMode = "ended";
            }
        }
    }

    update() {

        let time = this.item.game.timer.time;
        let deltaTime = this.item.game.timer.delta;
        
        let stepLength = 1/240;
        let steps = Math.min(8, Math.round(deltaTime/stepLength));

        for(let i = 0; i < steps; i++) {
            this.item.player.controller.updateControl(time, stepLength);
            Matter.Engine.update(this.item.physicsEngine, 1000*stepLength);
        }

        this.item.table.controller.update(this, deltaTime);
        let currentArray = this.item.papers;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let currentPaper = currentArray[i];
            currentPaper.controller.update(this, deltaTime);
        }
        
        this.item.startButton.alpha = this.item.buttonEnvelope;
        this.item.backButton.alpha = this.item.buttonEnvelope;

        this.item.scoreDisplay.controller.update(time, deltaTime);
    }

    stop() {
        this.item.keyboardInput.active = false;

        let currentArray = this.item.papers;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let curretPaper = currentArray[i];

            Matter.World.remove(this.item.physicsEngine.world, curretPaper.physicsBody);
            this.item.physicsLayer.removeChild(curretPaper.pixiLayer);
        }

        this.item.papers = [];
    }

    leftInput() {
        switch(this.item.interactionMode) {
            case "highscorePrompt":
                this._highscoreOver();
                break;
            case "highscore":
                if(this.item.arcadeHighscoreForm) {
                    this.item.arcadeHighscoreForm.controller.leftInput();
                }
                break;
            case "ended":
                this._callback_backClicked();
                break;
        }
    }

    rightInput() {
        switch(this.item.interactionMode) {
            case "highscorePrompt":
                this._showHighscoreForm();
                break;
            case "highscore":
                if(this.item.arcadeHighscoreForm) {
                    this.item.arcadeHighscoreForm.controller.rightInput();
                }
                break;
            case "ended":
                this._callback_startClicked();
                break;
        }
    }

    arcadeSubmit(aName) {
        this.item.game.name = aName;

        this.item.game.controller.submitHighscore();
        this._highscoreOver();
    }
}